import styled from "styled-components";
import Line from "components/atoms/line";
import { H1 } from "components/atoms/text";
import Form from "components/templates/editPassword/Form";

// 비밀번호 재설정 페이지
const EditPassword = () => {
  return (
    <div className="h-full">
      <Inner>
        <H1>비밀번호 재설정</H1>
        <Line className="my-5" />
        <Form />
      </Inner>
    </div>
  );
};

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 360px;
  height: 100%;
  margin: 0 auto;
  background-color: #fff;
  padding: 0 40px;
`;

export default EditPassword;
